import { StarIcon, HandThumbUpIcon, CheckCircleIcon, BoltIcon } from '@heroicons/react/24/outline';
import { VariableType } from 'types/domain/variable';

export const VariableTypeIcon = (type: VariableType, className?) => {
  switch (type) {
    case VariableType.BOOLEAN:
      return <HandThumbUpIcon className={className} />;
    case VariableType.SCORE:
      return <StarIcon className={className} />;
    case VariableType.OPTIONS:
      return <CheckCircleIcon className={className} />;
    case VariableType.ATTRIBUTE:
      return <BoltIcon className={className} />;
  }

  return null;
};

export const VariableTypeName = (type: VariableType) => {
  switch (type) {
    case VariableType.BOOLEAN:
      return 'Pass';
    case VariableType.SCORE:
      return 'Score';
    case VariableType.OPTIONS:
      return 'Options';
    case VariableType.ATTRIBUTE:
      return 'Attribute';
  }

  return null;
};
